import { mockClient, shippingClient } from 'domain/HttpClients';

export const fetch = (data = {}, cursor = null) => shippingClient
  .Post('/api/manifest/query')
  .withData(data)
  .withParams({
    cursor,
  })
  .send();

export const getManifestsWaybillsPdf = (manifestIds) => {
  const manifestIdsParams = manifestIds.map((manifestId) => `manifestIds=${manifestId}`).join('&');
  return shippingClient.Get(`/api/manifest/get-manifests-label-pdf?${manifestIdsParams}`).send();
};

export const getManifestLabelPdf = (manifestId) => getManifestsWaybillsPdf([manifestId]);
